import * as React from 'react';

import { cn } from '@/lib/utils';
import { hasSmallTextSize } from '@/components/ui/touch-target';

const Textarea = React.forwardRef<
	HTMLTextAreaElement,
	React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
	return (
		<textarea
			className={cn(
				'flex min-h-[40px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
				// Phones keep 16px text even when the caller passes text-sm, or
				// iOS Safari zooms in on focus.
				hasSmallTextSize(className) && 'max-md:text-base',
				className
			)}
			ref={ref}
			{...props}
		/>
	);
});
Textarea.displayName = 'Textarea';

export { Textarea };
